import React, {useMemo} from "react";
import {useGetAllUsersQuery} from "../../../../../../store/services/api/user-api";
import {Divider, Form, Input, Select, Tag,Collapse } from "antd";
import FilterContainer, {CoreFiltersBaseProps} from "../../../../components/FilterContainer";
import DateRangePicker from "../../../../../../components/forms/controls/DateRangePicker";
import {WorkOrderPriority, WorkOrderStatus, WorkOrderType} from "../../../../../../store/data/entities/work-order";
import {
  useGetAllBuildingsQuery,
  useGetAllFloorsQuery,
  useGetAllLocationsQuery
} from "../../../../../../store/services/api/building-api";
import {DateTime} from "luxon";

export default function LabourListScreenFilters({filter, onSubmit}: CoreFiltersBaseProps) {
  const { Panel } = Collapse;
  const {data: allUsers} = useGetAllUsersQuery();
  const buildingLeads = useMemo(() => {
    return allUsers?.filter(item => item.role === 'BuildingLead') ?? [];
  }, [allUsers]);
  const technicians = useMemo(() => {
    return allUsers?.filter(item => item.role === 'Technician') ?? [];
  }, [allUsers]);

  return (
    <FilterContainer
      onResetFilters={filter.resetFilters}
      onSubmit={onSubmit}
      isSubmitting={undefined}
    >
      <Collapse defaultActiveKey={['general','assignment','dates','priorityStatus','location']} ghost>
      <Panel header="General Info" key="general">
        <Form layout='vertical'>
          <Form.Item label='Reference'>
            <Input
              allowClear
              value={filter.getFilter('reference')}
              onChange={e => filter.setFilter('reference', e.target.value)}
            />
          </Form.Item>
          <Form.Item label='Description'>
            <Input
              allowClear
              value={filter.getFilter('description')}
              onChange={e => filter.setFilter('description', e.target.value)}
            />
          </Form.Item>
        </Form>
      </Panel>

      
      <Panel header="Assignment" key="assignment">
        <Form layout='vertical'>
          <Form.Item label='Owner'>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const text = String((option as any).label  || '');
              return text.toLowerCase().includes(input.toLowerCase());
            }}
            value={filter.getFilter('buildingLeadId')}
            onChange={val => filter.setFilter('buildingLeadId', val)}
            options={buildingLeads?.map(item => ({
              label: item.name,
              value: item.id
            }))}
          />
        </Form.Item>

        <Form.Item label='Technician'>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const text = String((option as any).label  || '');
              return text.toLowerCase().includes(input.toLowerCase());
            }}
            value={filter.getFilter('technicianId')}
            onChange={val => filter.setFilter('technicianId', val)}
            options={technicians?.map(item => ({
              label: item.name,
              value: item.id
            }))}
          />
        </Form.Item>
        </Form>
      </Panel>

      <Panel header="Dates" key="dates">
        <Form layout='vertical'>
        <Form.Item label='Date'>
          <DateRangePicker
            onStartDateChange={(value) => {
              filter.setFilter('startDate', value?.toISO() ?? undefined);
            }}
            onEndDateChange={(value) => {
              filter.setFilter('endDate', value?.toISO() ?? undefined);
            }}
            startDateValue={filter.getFilter('startDate') ? DateTime.fromISO(filter.getFilter('startDate')) : undefined}
            endDateValue={filter.getFilter('endDate') ? DateTime.fromISO(filter.getFilter('endDate')) : undefined}
          />
        </Form.Item>
        
        </Form>
      </Panel>

      <Panel header="Status" key="priorityStatus">
        <Form layout='vertical'>
          <Form.Item label='Priority'>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const text = String((option as any).children  || '');
              return text.toLowerCase().includes(input.toLowerCase());
            }}
            value={filter.getFilter('priority')}
            onChange={val => filter.setFilter('priority', val)}
          >
            <Select.Option value={WorkOrderPriority.Standard}>Standard</Select.Option>
            <Select.Option value={WorkOrderPriority.Important}>Important</Select.Option>
            <Select.Option value={WorkOrderPriority.Urgent}>Urgent</Select.Option>
            <Select.Option value={WorkOrderPriority.Emergency}>Emergency</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label='Status'>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const text = String((option as any).children  || '');
              return text.toLowerCase().includes(input.toLowerCase());
            }}
            value={filter.getFilter('statuses')}
            onChange={val => filter.setFilter('statuses', val)}
          >
            <Select.Option value={WorkOrderStatus.PendingApproval}>Pending Approval</Select.Option>
            <Select.Option value={WorkOrderStatus.Approved}>Approved</Select.Option>
            <Select.Option value={WorkOrderStatus.Rejected}>Rejected</Select.Option>
            <Select.Option value={WorkOrderStatus.InProgress}>In Progress</Select.Option>
            <Select.Option value={WorkOrderStatus.Completed}>Completed</Select.Option>
            <Select.Option value={WorkOrderStatus.Closed}>Closed</Select.Option>
            <Select.Option value={WorkOrderStatus.Cancelled}>Cancelled</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label='Type'>
          <Select
            mode="multiple"
            allowClear
            showSearch
            filterOption={(input, option) => {
              const text = String((option as any).children  || '');
              return text.toLowerCase().includes(input.toLowerCase());
            }}
            value={filter.getFilter('type')}
            onChange={val => filter.setFilter('type', val)}
          >
            <Select.Option value={WorkOrderType.Preventative}>Preventative</Select.Option>
            <Select.Option value={WorkOrderType.Corrective}>Corrective</Select.Option>
            <Select.Option value={WorkOrderType.Improvement}>Improvement</Select.Option>
          </Select>
        </Form.Item>

        </Form>
      </Panel>

      

      </Collapse>
    </FilterContainer>
  )
}
